import { render, staticRenderFns } from "./en.vue?vue&type=template&id=45846028&scoped=true&"
import script from "./en.vue?vue&type=script&lang=js&"
export * from "./en.vue?vue&type=script&lang=js&"
import style0 from "./en.vue?vue&type=style&index=0&id=45846028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45846028",
  null
  
)

export default component.exports